import { render, staticRenderFns } from "./_withdrawal.vue?vue&type=template&id=4675fa6f&"
import script from "./_withdrawal.vue?vue&type=script&lang=js&"
export * from "./_withdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports